// src/app/views/pages_predict_admin/score/rtPrAdScore.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const Score_LEET = Loadable(lazy(() => import("./Score_LEET")));
const Score_G5 = Loadable(lazy(() => import("./Score_G5")));
const Score_G7 = Loadable(lazy(() => import("./Score_G7")));

const rtPrAdScore = [
  { path: `pre/${EXAM_TYPES.LEET.rid_cd_ext}/score`, element: <Score_LEET /> },
  { path: `pre/${EXAM_TYPES.G5.rid_cd_ext}/score`, element: <Score_G5 /> },
  { path: `pre/${EXAM_TYPES.G7.rid_cd_ext}/score`, element: <Score_G7 /> },
];
export default rtPrAdScore;
